module.exports = __webpack_public_path__ + "static/media/hwwa.a2006800.md";